var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "vx-row mt-4" }, [
        _c(
          "div",
          { staticClass: "vx-col sm:w-1/1 w-full mb-2" },
          [
            _c("label", [_vm._v("Tipo Documento")]),
            _c(
              "v-select",
              {
                staticClass: "required-select",
                attrs: { options: _vm.documentTypeList, label: "name" },
                model: {
                  value: _vm.documentType,
                  callback: function($$v) {
                    _vm.documentType = $$v
                  },
                  expression: "documentType"
                }
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "no-options" }, slot: "no-options" },
                  [_vm._v("Nenhum registro encontrado!")]
                )
              ]
            )
          ],
          1
        )
      ]),
      _vm.documentType != null
        ? _c("div", { staticClass: "vx-row mb-6" }, [
            _c(
              "div",
              { staticClass: "vx-col w-full" },
              [
                _c(
                  "vue-dropzone",
                  {
                    ref: "fileUploadZone",
                    attrs: {
                      id: "upload",
                      "use-font-awesome": true,
                      options: _vm.dropzoneOptions,
                      "use-custom-dropzone-options": true,
                      max_number_of_files: 10,
                      useCustomSlot: true
                    },
                    on: {
                      "vdropzone-success": _vm.success,
                      "vdropzone-sending": _vm.sending,
                      "vdropzone-error": _vm.error,
                      "vdropzone-file-added": _vm.added,
                      "vdropzone-queue-complete": _vm.complete
                    }
                  },
                  [
                    _c("div", { staticClass: "dropzone-custom-content" }, [
                      _c("h3", { staticClass: "dropzone-custom-title" }, [
                        _vm._v("Arraste e solte para enviar os arquivos!")
                      ]),
                      _c("div", { staticClass: "subtitle" }, [
                        _vm._v("...ou selecione um arquivo do seu computador.")
                      ])
                    ])
                  ]
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.documentList.length > 0
        ? _c(
            "div",
            [
              _c(
                "vs-table",
                {
                  attrs: {
                    data: _vm.documentList,
                    "no-data-text": "Nenhum registro encontrado"
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var data = ref.data
                          return _vm._l(data, function(tr, indextr) {
                            return _c(
                              "vs-tr",
                              { key: indextr },
                              [
                                _c(
                                  "vs-td",
                                  { staticClass: "flex items-center" },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: _vm.icon(data[indextr].file),
                                        width: "34"
                                      }
                                    })
                                  ]
                                ),
                                _c("vs-td", [
                                  _vm._v(
                                    _vm._s(data[indextr].document_type.name)
                                  )
                                ]),
                                _c("vs-td", [
                                  _vm._v(
                                    _vm._s(
                                      data[indextr].file.created_at_formatted
                                    )
                                  )
                                ]),
                                _c("vs-td", [
                                  _vm._v(
                                    _vm._s(
                                      data[indextr].file.human_readable_size
                                    )
                                  )
                                ]),
                                _c(
                                  "vs-td",
                                  { staticStyle: { cursor: "pointer" } },
                                  [
                                    _vm.showPreviewButton(data[indextr].file)
                                      ? _c("feather-icon", {
                                          directives: [
                                            {
                                              name: "permission",
                                              rawName: "v-permission",
                                              value: "files.preview",
                                              expression: "'files.preview'"
                                            }
                                          ],
                                          staticClass:
                                            "h-5 w-5 mb-1 mr-3 stroke-current text-success",
                                          attrs: { icon: "EyeIcon" },
                                          on: {
                                            click: function($event) {
                                              return _vm.showPreview(
                                                data[indextr].file
                                              )
                                            }
                                          }
                                        })
                                      : _c("feather-icon", {
                                          directives: [
                                            {
                                              name: "permission",
                                              rawName: "v-permission",
                                              value: "files.download",
                                              expression: "'files.download'"
                                            }
                                          ],
                                          staticClass:
                                            "h-5 w-5 mb-1 mr-3 stroke-current text-success",
                                          attrs: { icon: "DownloadIcon" },
                                          on: {
                                            click: function($event) {
                                              return _vm.showPreview(
                                                data[indextr].file
                                              )
                                            }
                                          }
                                        }),
                                    _vm.showPreviewButton(data[indextr].file)
                                      ? _c("feather-icon", {
                                          directives: [
                                            {
                                              name: "permission",
                                              rawName: "v-permission",
                                              value: "files.download",
                                              expression: "'files.download'"
                                            }
                                          ],
                                          staticClass:
                                            "h-5 w-5 mb-1 mr-3 stroke-current text-success",
                                          attrs: { icon: "DownloadIcon" },
                                          on: {
                                            click: function($event) {
                                              return _vm.download(
                                                data[indextr].file
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _c("feather-icon", {
                                      staticClass:
                                        "h-5 w-5 mb-1 mr-3 stroke-current text-danger",
                                      attrs: {
                                        icon: "Trash2Icon",
                                        title: "Excluir"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.destroy(data[indextr])
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          })
                        }
                      }
                    ],
                    null,
                    false,
                    1955167181
                  )
                },
                [
                  _c(
                    "template",
                    { slot: "thead" },
                    [
                      _c("vs-th", [_vm._v("Arquivo")]),
                      _c("vs-th", [_vm._v("Tipo Documento")]),
                      _c("vs-th", [_vm._v("Data")]),
                      _c("vs-th", [_vm._v("Tamanho")]),
                      _c("vs-th", [_vm._v("Ação")])
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "vs-popup",
        {
          attrs: { title: "Visualizar Documento", active: _vm.previewImage },
          on: {
            "update:active": function($event) {
              _vm.previewImage = $event
            }
          }
        },
        [
          _c("img", {
            staticClass: "flex items-center",
            staticStyle: {
              margin: "0 auto",
              "max-width": "100%",
              "max-height": "100%"
            },
            attrs: { src: _vm.previewImage }
          })
        ]
      ),
      _c(
        "vs-popup",
        {
          attrs: { title: "Visualizar Documento", active: _vm.previewObject },
          on: {
            "update:active": function($event) {
              _vm.previewObject = $event
            }
          }
        },
        [
          _c("object", {
            staticStyle: { height: "60vh" },
            attrs: {
              data: _vm.previewObject,
              type: _vm.previewObjectType,
              width: "100%",
              height: "100%"
            }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }